webpackJsonp([12],{

/***/ 173:
/***/ (function(module, exports) {

module.exports = {"jugar":"Jugar","instrucciones":"Instrucciones"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.31eb7d236122b483941b.js